const OverflowContainer = ({ children, className, maxHeightClassName }) => (
  <div className={`w-full overflow-auto ${maxHeightClassName} ${className}`}>{children}</div>
);
export default OverflowContainer;
